import { jsx as _jsx } from "react/jsx-runtime";
import Avatar from "@mui/material/Avatar";
// Function to generate initials from the name
function stringAvatar(name) {
    const initials = name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();
    return {
        sx: {
            bgcolor: "#DFE3E8",
            color: "#637381",
            borderRadius: '12px',
        },
        children: initials,
    };
}
export const HAvatar = ({ name, imageSrc }) => {
    // If name is null or undefined, we can either return a default avatar or handle it differently
    const avatarProps = name ? stringAvatar(name) : {
        sx: {
            bgcolor: "#DFE3E8",
            color: "#637381",
            borderRadius: '12px',
        },
        children: "", // Empty initials if name is not provided
    };
    return (_jsx(Avatar, { variant: "rounded", ...(imageSrc ? { src: imageSrc } : avatarProps), alt: name || "Avatar" }));
};
